<template>
  <div>
    <div id="echart-line" ref="echarts" />
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    activeName: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      xDataName: [],
      renderingData: []
    }
  },
  methods: {
    initChart(name, xData, yData, xDatawx, chart_type, type) {
      const getchart = echarts.init(this.$refs.echarts)
      getchart.clear()
      getchart.off('click')
      getchart.clear()
      if (this.channel === 'wechat' && (xDatawx === 'peo' || xDatawx === 'peos')) {
        if (window.WWOpenData) {
          window.WWOpenData.initCanvas()
        }
        var items = xData.map((item) => {
          return { type: 'userName', id: item }
        })
        const result = new Promise((resolve, reject) => {
          window.WWOpenData.prefetch({ items }, (err, data) => {
            if (err) {
              return reject(err)
            }
            resolve(data)
          })
        })
        result
          .then((res) => {
            var data1 = []
            res.items.forEach((element) => {
              data1.push(element.data)
            })
            this.xDataName = data1
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        this.xDataName = xData
      }
      // this.xDataName = xData
      setTimeout(() => {
        var dataZoom = []
        var tooltip = {}
        var yName = ''
        if (chart_type !== 'tooltip') {
          if (xDatawx === 'peos') {
            tooltip = {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              },
              renderMode: 'richText'
            }
          } else {
            tooltip = {
              trigger: 'axis',
              axisPointer: {
                type: 'none'
              }
            }
          }
        }
        if (chart_type !== 'index') {
          dataZoom = [
            {
              orient: 'horizontal',
              show: true, // 控制滚动条显示隐藏
              realtime: true, // 拖动滚动条时是否动态的更新图表数据
              height: 15, // 滚动条高度
              start: 0, // 滚动条开始位置（共100等份）
              end: 100, // 滚动条结束位置
              bottom: '4%',
              zoomLock: false // 控制面板是否进行缩放
            }
          ]
        }
        if (type === 'woer') {
          yName = '单位/小时'
        } else {
          yName = ''
        }
        var option = {
          tooltip,
          legend: {
            data: name,
            // top: '0%',
            // right: '0%'
            type: 'scroll', // 设置图例为滚动类型
            orient: 'horizontal', // 横向显示图例
            height: 50, // 设置图例高度
            pageIconColor: '#ff781f', // 设置翻页箭头颜色
            pageTextStyle: {
              color: '#999' // 设置翻页数字颜色
            },
            pageIconSize: 11, // 设置翻页箭头大小
            textStyle: { // 设置图例文字的样式
              color: '#999',
              fontSize: 12
            },
            itemHeight: 10, // 设置图例项的高度
            itemWidth: 15, // 设置图例项的宽度
            right: '0%', // 设置图例左边距
            top: '0%' // 设置图例上边距
          },
          grid: {
            // 调整图表上下左右位置
            top: '18%',
            left: '5%',
            right: '5%',
            bottom: '15%',
            containLabel: true
          },
          dataZoom,
          xAxis: {
            type: 'category',
            data: this.xDataName
          },
          yAxis: {
            type: 'value',
            name: yName
          },
          series: yData,
          toolbox: { // 下载
            show: false, // 是否展示
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            orient: 'horizontal',
            left: 'left',
            top: 'top',
            feature: { // 配置项
              saveAsImage: {
                show: true,
                title: '保存图片'
              }, // 保存图表
              dataView: {
                show: true,
                title: '数据视图'
              }
            }
            // iconStyle: {
            //   color: '$color_main'
            // }
          }

        }
        getchart.setOption(option)
        // 随着屏幕大小调节图表
        window.addEventListener('resize', () => {
          getchart.resize()
        })
      }, 100)

      getchart.on('click', params => {
        if (params.seriesType === 'bar') {
          // 检查事件是否由柱状图触发
          // console.log('柱子被点击了！')
          // console.log('点击的数据是:', params.data) // 输出点击的柱子对应的数据
          // 你可以在这里处理点击后的逻辑
          if (this.type === 'perfo') {
            // this.activeName = '2'
            this.$emit('fun', params.data)
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#echart-line {
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>
